import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onBeforeUnmount } from "vue"
import { Message as ElMessage } from "element-ui"

import { getResultAPI, updateResultAPI } from "@/api/ocr/index"

import PictureList from "./PictureList.vue"
import ImgView from "./ImgView.vue"

import { useTextSelection } from "@vueuse/core"
import { useContextMenu } from "@/views/OCR/hooks/useContextMenu"
import { EnumOperated, OcrResult } from "@/api/ocr/type"
import { getBaseUrl } from "@/views/OCR/utils"

import ClipboardJS from 'clipboard'


export default /*#__PURE__*/_defineComponent({
  __name: 'OcrResult',
  props: {
    ocrResultId: { default: "" },
    isSave: { type: Boolean }
  },
  emits: ['save-res'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { ocrResultId: string, isSave: boolean }



const pictureList = ref<OcrResult.Res>([]) //OCR识别任务结果详情列表
const curIndex = ref(0) //当前页数
const fileName = ref("") //左边文件名
const currentTextArray = ref<string[]>([])
//获取数据
async function getResult() {
  // 请求新数据前，先清理数据缓存
  curIndex.value = 0
  pictureList.value = []
  const res = await getResultAPI(props.ocrResultId)
  const normalizedList = res.data
  fileName.value = normalizedList[0].filename
  const baseUrl = getBaseUrl()
  for (const item of normalizedList) {
    item.image = `${baseUrl}${item.image}`
  }
  pictureList.value = normalizedList
  currentTextArray.value = pictureList.value[curIndex.value].ocrPages[0].paragraphs
}
getResult()
const saveLoading = ref(false)
//点击保存
async function handleSave() {
  const data = {
    detailVOS	: pictureList.value,
    ocrTaskId: props.ocrResultId
  }
  saveLoading.value = true
  try {
    await updateResultAPI(data)
    ElMessage.success("保存成功！")
    emits('save-res', false)
  } finally {
    saveLoading.value = false
  }
}
// 编辑后存到对应的位置上
function handleChange(e: any) {
  emits('save-res', true)
  let newTextArr: string[] = []
  e.target.childNodes.forEach((item: any) => {
    if (item.childNodes.length) {
      item.childNodes.forEach((child: any) => {
        child.textContent && newTextArr.push(child.textContent)
      })
    } else {
      item.textContent && newTextArr.push(item.textContent)
    }
  })
  pictureList.value[curIndex.value].ocrPages[0].paragraphs = newTextArr
}
// 获取鼠标选中的文本
const textSelection = useTextSelection()
const selectedText = ref('')
watch(() => textSelection.text.value, (newValue) => {
  if (newValue) {
    selectedText.value = newValue
  }
}, { deep: true })
// 切换当前索引时获取对应的text
watch(
  () => curIndex.value,
  (newValue) => {
    currentTextArray.value = pictureList.value[newValue].ocrPages[0].paragraphs
  }
)
const textRef = ref()
const preSelectRange = ref()
const { contentRef, onFileContextmenu} = useContextMenu()
let newNode: Text | null = null

const handleOperated = (e: MouseEvent) => {
  switch((e.target as HTMLDivElement)?.dataset.type) {
    case EnumOperated.COPY:
      if (!selectedText.value) return
      navigator.clipboard.writeText(selectedText.value)
        .then(() => {
          ElMessage.success('复制成功')
        })
        .catch(() => {
          ElMessage.error('复制失败')
        })
      break
    case EnumOperated.STICKUP:
      newNode = document.createTextNode(selectedText.value)
      preSelectRange.value.deleteContents()
      preSelectRange.value.insertNode(newNode)
      pictureList.value[curIndex.value].ocrPages[0].paragraphs[0] = textRef.value.innerText
      break
    case EnumOperated.DELETE:
      preSelectRange.value.deleteContents()
      pictureList.value[curIndex.value].ocrPages[0].paragraphs[0] = textRef.value.innerText
      break
  }
}
const handleBlur = () => {
  const selection: Selection | null  = window.getSelection()
  preSelectRange.value = selection?.getRangeAt(0)
}
var clipboard = new ClipboardJS('.copy-btn')
clipboard.on('success', function (e: ClipboardJS.Event) {
  ElMessage.success('复制成功')
  e.clearSelection()
})
onBeforeUnmount(() => {
  clipboard.destroy()
})
expose({
  handleSave
})

return { __sfc: true,props, emits, pictureList, curIndex, fileName, currentTextArray, getResult, saveLoading, handleSave, handleChange, textSelection, selectedText, textRef, preSelectRange, contentRef, onFileContextmenu, newNode, handleOperated, handleBlur, clipboard, PictureList, ImgView }
}

})